export default "__VITE_ASSET__spL4YFSZ__"